import React from 'react';
import { UnsupportedBrowserBanner } from '@ami/react/shared';
import { TestBanner } from '@ami/react/shared';
import { Container, Navbar, Nav } from 'reactstrap';
import PropTypes from 'prop-types';
import dealerGroupsLookupServices from '../services/dealerGroupsLookupServices';
import { Thumbnail } from '@ami/react/core';

export default class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dealerGroup: null,
    };
  }

  static propTypes = {
    dealerGroupId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    if (this.props.dealerGroupId) {
      dealerGroupsLookupServices
        .getById(this.props.dealerGroupId)
        .then((dealerGroup) => {
          this.setState({ dealerGroup });
        });
    }
  }

  render() {
    const showTestBanner =
      process.env.NX_APP_SHOW_TEST_BANNER &&
      process.env.NX_APP_SHOW_TEST_BANNER.toString() === 'true';
    const { dealerGroup } = this.state;
    return (
      <div>
        <UnsupportedBrowserBanner />
        {showTestBanner && <TestBanner />}
        <Navbar color="dark" dark expand="lg">
          <Container>
            <img
              src="/assets/ami_logo.png"
              alt="AMI"
              className="navbar-brand-icon"
            />
            <Nav
              className="ms-auto d-none d-lg-flex d-xl-flex flex-column align-items-end"
              navbar
            >
              <div className="d-flex">
                {dealerGroup && (
                  <Thumbnail
                    className="mt-0 me-2"
                    imageUrl={this.state.dealerGroup.imageUrl}
                  />
                )}
                {dealerGroup && (
                  <label className="nav-item nav-link mb-0">
                    {dealerGroup.name}
                  </label>
                )}
              </div>
            </Nav>
          </Container>
        </Navbar>
        <br />
      </div>
    );
  }
}
